import { Select } from "antd";
import Box from "components/base/Box";
import WhiteSpace from "components/base/WhiteSpace";
import useSizeMediaQuery from "hooks/useSizeMediaQuery";
import React, { useCallback } from "react";
import { useLocale } from "../hooks";

interface Props {
  style?: React.CSSProperties;
}

const LanguageSwitcher: React.FC<Props> = (props) => {
  const { language, setLanguage } = useLocale();

  const size = useSizeMediaQuery();

  const isSmall = size === "xs";

  const handleLanguageChange = useCallback(
    (lang: "vi" | "en") => {
      setTimeout(() => {
        setLanguage(lang);
      }, 0);
    },
    [setLanguage]
  );

  return (
    <Select
      bordered={false}
      value={language}
      onChange={handleLanguageChange}
      showArrow={!isSmall}
      {...props}
    >
      <Select.Option value={"en"}>
        <Box display="flex" alignItems="center">
          <span
            role="img"
            aria-label="English"
            style={{ fontSize: isSmall ? 24 : 16 }}
          >
            🇺🇸
          </span>
          {!isSmall && (
            <>
              <WhiteSpace horizontal size="sm" />
              <span>English</span>
              <WhiteSpace horizontal size="xs" />
            </>
          )}
        </Box>
      </Select.Option>
      <Select.Option value={"vi"}>
        <Box display="flex" alignItems="center">
          <span
            role="img"
            aria-label="Tiếng Việt"
            style={{ fontSize: isSmall ? 24 : 16 }}
          >
            🇻🇳
          </span>
          {!isSmall && (
            <>
              <WhiteSpace horizontal size="sm" />
              <span>Tiếng Việt</span>
              <WhiteSpace horizontal size="xs" />
            </>
          )}
        </Box>
      </Select.Option>
    </Select>
  );
};

export default LanguageSwitcher;
